module.exports = __webpack_public_path__ + "static/media/Data_insight_mo_2-1.4dee1a8e.svg";